// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"_8UQjn","withSvgCoreBadge":"_8UQjn"};